import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import LKModal from '../Modal/Modal';
import './PowerUpdate.scss';

class PowerUpdate extends PureComponent {
    static propTypes = {
        hitPowerAPI: PropTypes.func,
        getPowerUpdate: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.phoneNo = React.createRef();
        this.state = {
            invalidPhoneNumber: false,
            shouldShowError: false
        };
        this.validatePhoneNumber = this.validatePhoneNumber.bind(this);
    }

    validatePhoneNumber = () => {
        const phoneVal = this.phoneNo.current.value;
        const regexPhone = /^[0]?[789]\d{9}$/;
        if (regexPhone.test(phoneVal)) {
            this.props.hitPowerAPI(phoneVal);
        } else {
            this.setState({ invalidPhoneNumber: true });
        }
        this.setState({ shouldShowError: true });
    }

    render() {
        const { showModal, hideHandler, enterPowerRespMsg } = this.props;
        let localConfig = {
            backdrop: true,
            keyboard: true
        };
        localConfig = Object.assign({}, localConfig);
        return (
            <LKModal {...localConfig} hideHandler={() => hideHandler()} showModal={showModal} headerTitle="Enter Phone Number">
                <div className="powerUpdateModal">
                    <div className="powerUpdateModal_desc">
                        Submit prescription for your existing order at lenskart. Enter Mobile No. you mentioned in the order and we will SMS a link to you for submitting power:
                        <div className="powerUpdateModal_formControls">
                            <input ref={this.phoneNo} type="text" className="form-control" id="phoneNo" placeholder="Enter Phone no" />
                        </div>
                    </div>
                    <button
                        type="button"
                        className="powerUpdateModal_btn"
                        data-dismiss="modal"
                        onClick={() => {
                            this.setState({
                                invalidPhoneNumber: false
                            });
                            this.validatePhoneNumber();
                        }}
                    >Submit</button>
                    <div className="powerUpdateModal_pfError">
                        {this.state.shouldShowError && this.state.invalidPhoneNumber && <div className="powerUpdateModal_pfError_error alert alert-danger">Please enter a valid phone number.</div>}
                        {this.state.shouldShowError && enterPowerRespMsg && !this.state.invalidPhoneNumber && <div className="powerUpdateModal_pfError_error alert alert-danger" dangerouslySetInnerHTML={{ __html: enterPowerRespMsg }}></div>}
                    </div>
                </div>
            </LKModal>
        );
    }
}

export default PowerUpdate;





